<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import {activePickerItem} from "./gp-context-items";
    import {season} from './gp.js';
    import jQuery from "jquery";
    import {onMount, afterUpdate} from "svelte";
    import "./libs/jquery-ui.min.js";
    import "./libs/jquery.ui.touch-punch.min.js";

    const maxHeightPX = 85;
    const minHeightPX = 25;
    let trans = getGPTransFunc("gp-plantpicker");
    export let plant;
    let domThis;
    $: itemSize = parseInt(plant.height) < 150 ? parseInt(plant.height) * (maxHeightPX - minHeightPX) / 150 + minHeightPX : maxHeightPX;
    $: gardenerSize = parseInt(plant.height) > 240 ? 200 * maxHeightPX / parseInt(plant.height) : null;



    function selectItem(plant) {
        if (plant.enabled)
            $activePickerItem = plant;
        else {
            var pck = plant.package;
            if (pck === "premium" || !GPSettings.products.premium_database.active)
                GPSettings.upgradeClass.showOnlyInPremium("plants");
            else
                GPSettings.upgradeClass.showOnlyInPremium("package_" + pck);
        }
    }

    onMount(() => {
        jQuery(domThis).find('.GPPlantPickerImage').draggable({
            opacity: 0.7,
            helper: function (el) {
                return jQuery(el.target).clone()
            },
            cursorAt: {bottom: -3, left: 0},
            start: () => selectItem(plant),
            appendTo: "body"
        });
    })

    afterUpdate(() => {
        jQuery(domThis).find('[data-toggle="tooltip"]').tooltip();
    })
</script>


<div on:click={() => selectItem(plant)}
     role="button"
     class="list-group-item GPPlantPickerItem"
     class:premiumDisabled={!plant.enabled}
     class:enabled={plant.enabled}
     class:selected={$activePickerItem===plant}
     class:unfitForSeason={!plant.fitsToSeason}
     class:unfitForProject={!plant.fitsToProject}
     bind:this={domThis}
     GPItem="{plant.id}">

    {#if gardenerSize}<img src="img/nicons/gardener.svg" class="GPPlantPickerGardener" style="height:{gardenerSize}px">{/if}
    <img class="GPPlantPickerImage" src="{plant.staticGetPathForThumb($season, true)}" style="max-height:{itemSize}px"/>
    <div class="GPPlantPickerItemName">{@html plant.displayName}</div>
    {#if $activePickerItem===plant}<a on:click={() => {GP.app.showDetailsOfItem($activePickerItem)}} class="helpIcon"><i class="fa fa-question-circle"></i></a>{/if}
    {#if !plant.fitsToProject}<a data-toggle="tooltip" data-placement="bottom" title="{trans('Not optimal for specified conditions')}" class="noticeIcon"><i class="fa fa-exclamation-circle"></i></a>{/if}
    {#if !plant.fitsToSeason}<a data-toggle="tooltip" data-placement="bottom" title="{trans('Switch the season to add this plant to project')}" class="noticeIcon"><i class="fa fa-exclamation-circle"></i></a>{/if}

</div>